import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Col } from 'antd';
import HeaderBack from '../../../components/mobile/HeaderBack';
import LoginForm from '../../../components/mobile/LoginForm';

function MobileLoginWithEmailScreen() {
  const { t } = useTranslation(['user-account', 'common']);
  const history = useHistory();

  const onBack = () => {
    history.push('/user-account/account-credential')
  }

  const onConfirm = () => {

  }

  return (
    <>
      <HeaderBack
        onBack={onBack}
        text={t('user-account:loginWithEmail.previousPage')}
        title={t('user-account:loginWithEmail.title')}
        subtitle={t('user-account:loginWithEmail.subtitle')}
      />
      <LoginForm
        onSubmit={onConfirm}
        onSubmitBtnText={t('common:button.confirmSaveChange')}
      />
    </>
  );
}

export default MobileLoginWithEmailScreen;
